const AuthActionTypes = {
  SET_TOKEN: 'SET_TOKEN',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_USER_ROLE: 'SET_USER_ROLE',
  REMOVE_USER_DATA: 'REMOVE_USER_DATA',
  REMOVE_TOKEN: 'REMOVE_TOKEN',
  SHOW_TOAST: 'SHOW_TOAST',
  SET_LOCATION: 'SET_LOCATION',
  SET_TENANT: 'SET_TENANT',
};

export default AuthActionTypes;
